"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intl = require("@kyruus/intl");
const messages = (0, _intl.defineMessages)({
  share: {
    id: 'socialshare.share',
    description: 'Label text for share',
    defaultMessage: 'Share:'
  },
  print: {
    id: 'socialshare.print',
    description: 'Label text for the print action in the social share toolbar',
    defaultMessage: 'Print'
  },
  printAriaLabel: {
    id: 'socialshare.print.ariaLabel',
    description: 'Aria label text for the print action in the social share toolbar',
    defaultMessage: 'Print page'
  },
  email: {
    id: 'socialshare.email',
    description: 'Label text for the email action in the social share toolbar',
    defaultMessage: 'Email'
  },
  emailAriaLabel: {
    id: 'socialshare.email.ariaLabel',
    description: 'Aria label text for the email action in the social share toolbar',
    defaultMessage: 'Share via email'
  },
  facebook: {
    id: 'socialshare.facebook',
    description: 'Label text for the Facebook action in the social share toolbar',
    defaultMessage: 'Facebook'
  },
  facebookAriaLabel: {
    id: 'socialshare.facebook.ariaLabel',
    description: 'Aria label text for the facebook action in the social share toolbar',
    defaultMessage: 'Share via facebook'
  },
  twitterX: {
    id: 'socialshare.twitter',
    description: 'Label text for the X action in the social share toolbar',
    defaultMessage: 'X'
  },
  twitterXAriaLabel: {
    id: 'socialshare.twitter.ariaLabel',
    description: 'Aria label text for the twitter action in the social share toolbar',
    defaultMessage: 'Share via X'
  },
  profileLink: {
    id: 'socialshare.profileLink',
    description: 'Label text for the profile link action in the social share toolbar',
    defaultMessage: 'Profile'
  },
  profileLinkAriaLabel: {
    id: 'socialshare.profileLink.ariaLabel',
    description: 'Aria label text for the profile link in the social share toolbar',
    defaultMessage: 'Copy provider profile url link'
  }
});
var _default = exports.default = messages;